import * as max from '../max-length-validators';

export default {
  name: 'county',
  label: 'checkout.address.field.label.county.text',
  maxLength: 35,
  validate: max.lengthAddress(35),
};
